<template>
<div id="container">
 <b-carousel :arrow-both="false" :arrow-hover="false" :autoplay="false" :repeat="false">
        <b-carousel-item :key="0"><a class="image">
          <img v-if="this.$store.state.preferences.locale == 'ja'" src="../../../public/img/slide_intro.png">
          <img v-else src="../../../public/img/slide-intro-en.png">
        </a></b-carousel-item>
        <b-carousel-item :key="1"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_one')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_one')}}</p>
          <video src="../../../public/video/program.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="2"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_two')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_two')}}</p>
          <video src="../../../public/video/connect.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="3"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_three')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_three')}}</p>
          <video src="../../../public/video/graph.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="4"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_four')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_four')}}</p>
          <video src="../../../public/video/create.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="5"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_five')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_five')}}</p>
          <video src="../../../public/video/invite.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="6"><a class="image">
          <h1 class="title">{{$t('app.dashboard.carousel.title_six')}}</h1>
          <p class="text">{{$t('app.dashboard.carousel.text_six')}}</p>
          <video src="../../../public/video/join.mp4" muted autoplay loop />
        </a></b-carousel-item>
        <b-carousel-item :key="7"><a class="image">
          <img v-if="this.$store.state.preferences.locale == 'ja'" src="../../../public/img/slide_last.png">
          <img v-else src="../../../public/img/slide-last-en.png">
        </a></b-carousel-item>
</b-carousel>
</div>
</template>

<script>
export default {
    
}
</script>
<style scoped>
#container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 15;
  width: 85%;
  max-width: 900px;
}

.carousel {
  position: relative;
  background: #fff;
}
.carousel >>> .carousel-items {
  padding: 40px 40px 0 40px;
}
.carousel >>> .carousel-items .carousel-item a:hover {
  opacity: 1;
}
.carousel >>> .carousel-items .carousel-item.is-active {
  display: block;
}
.carousel >>> .carousel-items .carousel-item .title {
  position: relative;
  padding: 0;
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  border-bottom: 3px solid #2c6ac4;
}
.carousel >>> .carousel-items .carousel-item .title:before {
  margin-right: 10px;
  font-family: 'Font Awesome 5 Free';
  content: "\f0da";
  font-weight: 900;
  color: #2c6ac4;
  font-size: 1.875rem;
  vertical-align: middle;
}
.carousel >>> .carousel-items .carousel-item .text {
  position: relative;
  padding-top: 10px;
  margin-bottom: 1.5em;
  font-size: 1rem;
  line-height: 1.4;
  color: #333;
}
.carousel >>> .carousel-items .carousel-item img {
  display: block;
  margin: auto;
  max-width: 100%;
  -webkit-backface-visibility: hidden;
}
.carousel >>> .carousel-indicator {
  height: 50px;
}
.carousel >>> .carousel-indicator.has-custom {
  -webkit-overflow-scrolling: touch;
}
.carousel >>> .carousel-indicator.is-inside {
  position: relative;
}
.carousel >>> .carousel-arrow .icon.has-icons-left {
  left: 8px;
}
.carousel >>> .carousel-arrow .icon.has-icons-left i:before {
  font-family: 'Font Awesome 5 Free';
  content: "\f053";
  font-weight: 900;
}
.carousel >>> .carousel-arrow .icon.has-icons-right {
  right: 8px;
}
.carousel >>> .carousel-arrow .icon.has-icons-right i:before {
  font-family: 'Font Awesome 5 Free';
  content: "\f054";
  font-weight: 900;
}
.carousel >>> .carousel-arrow .icon.has-icons-left,
.carousel >>> .carousel-arrow .icon.has-icons-right {
  top: calc(50% + 25px);
  transform: translateY(-50%);
  color: #2c6ac4;
  cursor: pointer;
  outline: 0;
}
.carousel >>> .carousel-arrow .icon.has-icons-left i:before,
.carousel >>> .carousel-arrow .icon.has-icons-right i:before {
  font-size: 1.875rem;
}
</style>
